import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clipboard-2, copy, list"><path fillRule="evenodd" clipRule="evenodd" d="M7 3.75C7 2.7835 7.7835 2 8.75 2H15.25C16.2165 2 17 2.7835 17 3.75V4H19.25C20.2165 4 21 4.7835 21 5.75V20.25C21 21.2165 20.2165 22 19.25 22H4.75C3.7835 22 3 21.2165 3 20.25V5.75C3 4.7835 3.7835 4 4.75 4H7V3.75ZM8.5 6.25C8.5 6.38807 8.61193 6.5 8.75 6.5H15.25C15.3881 6.5 15.5 6.38807 15.5 6.25V3.75C15.5 3.61193 15.3881 3.5 15.25 3.5H8.75C8.61193 3.5 8.5 3.61193 8.5 3.75V6.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClipboard2;
